<template>
    <modal title="Vertrag auswählen">
        <ion-radio-group>
            <ion-item v-for="(contract, key) in contractsForFeature" :key="key">
                <ion-label text-wrap>
                    {{ contract.Name }}
                    <span style="white-space: nowrap;"
                        >({{ contract.ContractIdFormatted }})
                    </span>
                    <div v-if="getLicensePlate(key) !== ''">
                        Kennzeichen:
                        <span style="white-space: nowrap;">{{
                            getLicensePlate(key)
                        }}</span>
                    </div>
                </ion-label>
                <base-radio
                    :self="key"
                    v-model="selectedContractId"
                ></base-radio>
            </ion-item>
        </ion-radio-group>
        <template v-slot:footer>
            <ion-button expand="block" @click="changeContract()"
                >Bestätigen</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal";
import BaseRadio from "@/components/BaseRadio";

export default {
    components: {
        Modal,
        BaseRadio,
    },
    props: {
        contractId: {
            required: true,
            type: String,
        },
        feature: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            selectedContractId: this.contractId,
        };
    },
    mounted() {
        for (let contractKey in this.contractsForFeature) {
            let contract = this.contractsForFeature[contractKey];
            if (
                contract.Sparte === "KFZ" &&
                !this.$store.state.contractsDetails.all[contractKey]
            ) {
                this.$store.cache.dispatch(
                    "contractsDetails/getContractDetails",
                    contractKey
                );
            }
        }
    },
    computed: {
        contractsForFeature() {
            let result = {};
            const contracts = this.$store.state.contracts;
            for (let key in contracts) {
                if (
                    "Features" in contracts[key] &&
                    this.feature in contracts[key].Features
                ) {
                    result[key] = contracts[key];
                }
            }
            return result;
        },
    },
    methods: {
        getLicensePlate(contractId) {
            let result = "";
            const constractsDetails = this.$store.state.contractsDetails;
            if (
                constractsDetails.all[contractId] &&
                "KfzKennzeichen" in constractsDetails.all[contractId]
            ) {
                result = constractsDetails.all[contractId].KfzKennzeichen;
            }
            return result;
        },
        changeContract() {
            const motivesConfig = this.$store.state.motivesConfig;
            let selectedMotive = Object.values(
                this.$store.state.contracts[this.selectedContractId].Motives
            )[0];
            let motivePath = "berater";
            for (let key in motivesConfig) {
                if (motivesConfig[key].motive === selectedMotive) {
                    motivePath = motivesConfig[key].path;
                    break;
                }
            }
            this.$router.replace({
                name: this.$route.name,
                params: {
                    motive: motivePath,
                    contractId: this.selectedContractId,
                },
            });
            // if (
            //     this.$route.name === "services-unwetterwarnung" ||
            //     this.$route.name === "unwetterwarnung"
            // ) {
            //     this.$store.dispatch(
            //         "unwetterwarnungen/getDevicesForContract",
            //         this.selectedContractId
            //     );
            // } else
            if (this.$route.name.includes("schadensmeldung")) {
                this.$store.commit("setResetSchadensmeldungFormData", true);
            }
            // else if (
            //     this.$route.name === "services-biketrax" ||
            //     this.$route.name === "biketrax"
            // ) {
            //     this.$store.dispatch("biketrax/getEbikeTrackerStatus", {
            //         vertragsnummer: this.selectedContractId,
            //         pushtoken: this.$store.state.pushToken,
            //     });
            // }
            this.$ionic.modalController.dismiss();
        },
    },
};
</script>

<style></style>
